import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import queryString from 'query-string';
import TableHeader from 'admin/components/shared/TableHeaders';
import TableRows from 'admin/components/shared/TableRows';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Pager from 'admin/components/shared/Pager';
import { getKioskMaintenances } from 'admin/actions/devices';
import { toQueryParams, formatDate } from 'admin/utils';
import MaintenanceBadgeList from './MaintenanceBadgeList';
import styles from './styles.scss';

class KioskMaintenance extends Component {

  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 20 };
    this.params = queryString.parse(this.props.location.search);
  }

  componentWillMount() {
    this.fetchKioskMaintenances();
  }

  onChangePage = (page) => {
    this.fetchKioskMaintenances({ page });
  }

  fetchKioskMaintenances(pagination) {
    const pageParams = Object.assign({}, this.defaultPagination, pagination);
    const params = Object.assign({}, pageParams, { kiosk_id: this.params.kiosk_id });
    this.props.getKioskMaintenances(toQueryParams(params, true));
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'デバイス管理', href: '/settings/devices/', active: false },
      { value: 'メンテナンス履歴', href: '', active: true },
    ];
    const columns = [
      { label: '日時', align: 'center', size: 2 },
      { label: 'メンテナンス実施項目', align: 'center', size: 10 },
    ];
    const rows = this.props.kioskMaintenances.rows.map(kioskMaintenance => [
      { data: (<span>{formatDate(kioskMaintenance.updated_at)}</span>), align: 'center' },
      { data: (<MaintenanceBadgeList kioskMaintenance={kioskMaintenance} />), align: 'left' },
    ]);

    return (
      <div>
        <Breadcrumb items={crumb} />
        <div styleName="headline">端末ID：{this.params.kiosk_id}　端末名：{this.params.kiosk_name}</div>
        <div styleName="list-table">
          <TableHeader columns={columns} />
          <TableRows rows={rows} columns={columns} />
        </div>
        <Pager
          pagination={this.props.kioskMaintenances.pagination}
          onChangePage={this.onChangePage}
        />
      </div>
    );
  }
}

KioskMaintenance.defaultProps = {
  getKioskMaintenances: PropTypes.func,
  kioskMaintenances: { rows: [], pagination: {} },
};

KioskMaintenance.propTypes = {
  getKioskMaintenances: PropTypes.func,
  kioskMaintenances: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      updated_at: PropTypes.string,
      coin_jam: PropTypes.bool,
      printer_roll: PropTypes.bool,
      cleaning: PropTypes.bool,
      other: PropTypes.bool,
    })),
    pagination: PropTypes.shape({
      has_next: PropTypes.bool,
      has_prev: PropTypes.bool,
      max_page: PropTypes.number,
      per_page: PropTypes.number,
      current: PropTypes.number,
    }),
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = state => ({
  kioskMaintenances: state.device.kioskMaintenances,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getKioskMaintenances,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(KioskMaintenance, styles));
